


import React from 'react';
import Svg, { Circle, ClipPath, Defs, G, Path, Rect } from 'react-native-svg';

interface ChatCircleDotsProps {
    size?: number;
    color?: string;
}

const ChatCircleDots: React.FC<ChatCircleDotsProps> = ({ size = 25, color = '#7185A0' }) => (
    <Svg width={size} height={size} viewBox="0 0 25 24" fill="none">
        <G clipPath="url(#clip0_155_7161)">
            <Path d="M12.5 13.125C13.1213 13.125 13.625 12.6213 13.625 12C13.625 11.3787 13.1213 10.875 12.5 10.875C11.8787 10.875 11.375 11.3787 11.375 12C11.375 12.6213 11.8787 13.125 12.5 13.125Z" fill="#7185A0" />
            <Path d="M8.375 13.125C8.99632 13.125 9.5 12.6213 9.5 12C9.5 11.3787 8.99632 10.875 8.375 10.875C7.75368 10.875 7.25 11.3787 7.25 12C7.25 12.6213 7.75368 13.125 8.375 13.125Z" fill="#7185A0" />
            <Path d="M16.625 13.125C17.2463 13.125 17.75 12.6213 17.75 12C17.75 11.3787 17.2463 10.875 16.625 10.875C16.0037 10.875 15.5 11.3787 15.5 12C15.5 12.6213 16.0037 13.125 16.625 13.125Z" fill="#7185A0" />
            <Path d="M7.99356 19.7917C9.88406 20.8858 12.108 21.2551 14.2506 20.8307C16.3933 20.4062 18.3084 19.217 19.6391 17.4848C20.9697 15.7526 21.625 13.5956 21.4827 11.4159C21.3404 9.2363 20.4103 7.18277 18.8657 5.63825C17.3212 4.09372 15.2677 3.16361 13.088 3.02132C10.9084 2.87904 8.75138 3.53429 7.01916 4.86492C5.28695 6.19555 4.09777 8.11072 3.67333 10.2534C3.24889 12.396 3.61817 14.6199 4.71231 16.5104L3.5395 20.012C3.49543 20.1441 3.48903 20.286 3.52103 20.4215C3.55302 20.5571 3.62215 20.6811 3.72065 20.7796C3.81915 20.8781 3.94314 20.9472 4.07871 20.9792C4.21429 21.0112 4.3561 21.0048 4.48825 20.9607L7.99356 19.7917Z" stroke="#7185A0" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" />
        </G>
        <Defs>
            <ClipPath id="clip0_155_7161">
                <Rect width="24" height="24" fill="white" transform="translate(0.5)" />
            </ClipPath>
        </Defs>
    </Svg>
);

export default ChatCircleDots;
